import React from "react";

import visitStoreImg from "../../assets/images/visit-store-img.png";
import findImg from "../../assets/images/find-loc.png";
import { useNavigate } from "react-router-dom";

export default function VisitStoreBanner() {
  const navigate = useNavigate();

  return (
    <section className="wrapper">
      <div id="visit-store-banner-section">
        <div className="visit-store-banner-content">
          <h2>
            VISIT US TODAY TO SAVE
            <br />
            UP TO 20%
          </h2>

          <p>
            Whether you're stopping by for a hearty meal at our grill or stocking up on farm-fresh goods, homemade treats, and pantry
            essentials, we've got something special for you.
          </p>

          <div className="visit-store-banner-actions">
            <button className="visit-store-primary-btn" onClick={() => (window.location.href = "https://share.google/9lqJRYSi6i52639Km")}>
              <img src={findImg} width={17} height={21} />
              FIND MAIN'S
            </button>

            <button className="visit-store-secondary-btn" onClick={() => navigate("/store/vendors")}>SEE WHAT'S AVAILABLE</button>
          </div>
        </div>

        <div className="visit-store-banner-image-wrapper">
          <img src={visitStoreImg} alt="Visit Store" className="visit-store-banner-image" />
        </div>
      </div>
    </section>
  );
}
